import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit, Delete } from "@mui/icons-material";
import { Button, Card, CardContent, Chip, GridLegacy as Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,  InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  DialogType, FormActions, getLabelMunicipio } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";






const SucursalesYupValidation = yup.object({
  municipio:yup.object({
    label:yup.string(),
    value:yup.number()
}),
cod_erp:yup.string().optional().nullable().notRequired(),
  direccion:yup.string().optional().nullable().notRequired(),
  celular:yup.string().notRequired().nullable().optional(),
  descripcion:yup.string().optional().nullable().notRequired(),
});


const AddressYupValidation = yup.object({
  municipio:yup.object({
    label:yup.string(),
    value:yup.number()
}).test("is_selected",(value,ctx)=>{
  
   if(  !value.value  ){
    return  ctx.createError({ message: 'Seleccione un municipio' })
   }
   
    return true;
}),
cod_erp:yup.string().optional().nullable().notRequired(),
direccion_contacto:yup.string().required(),
  celular:yup.string().notRequired().nullable().optional(),
  descripcion:yup.string().required()
});

const ContactosYupValidation = yup.object({
  usuario_cliente:yup.object().required(),

 
});


const ProductoPortafolioYupValidation = yup.object({
  producto:yup.object().required(),
  criterio_aceptacion:yup.string().required(),
});

const schema = yup.object({
  cod_tipo_cliente: yup.string().required(),
  razon_social: yup.string().required(),
  nit: yup.string().required(),
  cod_erp: yup.string().required(),
  email_notificaciones: yup.string().email().notRequired(),
  celular_notificaciones: yup.string().notRequired().nullable().optional(),
  direcciones:yup.array(AddressYupValidation),
  productos:yup.array(ProductoPortafolioYupValidation),
  vendedor:yup.object().required()
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};


const AddressListItem  = ({
  onDeleteIcon,
  cod=null,
  municipio,
  descripcion,
  direccion_contacto,
  celular,
  label_municipio,
  itemRenderProps={}
})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{descripcion} - {municipio?.label || label_municipio}</Typography> 
          <Typography>DIR: {direccion_contacto}</Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton disabled={ cod && itemRenderProps.delete === false}  onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}
const SucursalesERP  = ({
  onDeleteIcon,
  municipio,
  cod_erp,
  direccion,
  celular,
  label_municipio='',
  direccion_contacto='',
  itemRenderProps = {}

})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{cod_erp || '001'} - {municipio?.label_municipio || label_municipio}</Typography> 
          <Typography>Dir: { direccion_contacto}</Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton disabled={itemRenderProps.delete === false} onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}
const ContactosListItem  = ({
  onDeleteIcon,

  itemRenderProps = {},
  usuario_cliente = {},
   ...props
})=>{
  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{usuario_cliente.usuario}</Typography> 
          <Typography>N° ID: {usuario_cliente.nro_identificacion}</Typography>
          <Typography>Cel: {usuario_cliente.celular}</Typography>
          <Typography>Email: {usuario_cliente.email}</Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton disabled={ usuario_cliente.cod && itemRenderProps.delete === true} onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

const ProductosListItem  = ({
  onDeleteIcon,
  producto,
  nombre_proucto='',
  criterio_aceptacion,
  ...props

})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{producto?.label }</Typography> 
          <Typography>Criterio: {criterio_aceptacion}</Typography>
          
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

export const MaestroClientes = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [vendedores,setVendedores] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [productosOptions, setProductosOptions] = useState([]);
  const [usuariosOptions, setUsuariosOptions] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
      await loadRoles();
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadRoles = async()=>{
      console.log("profile",profile);
      const  {data:{value}} = await AxiosInstance.post(`maestros-marketplace/get-clasificacion-clientes-filtro/${profile.cod_cia || ''}`);
      setRoles(value);
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post(`maestros-marketplace/get-lista-clientes/${profile.cod_cia || ''}`,{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data.map( item=>({...item,
      tipo_cliente:item.criterios_clasificacion.TIPO?.mayor_value,
      subtipo_cliente:item.criterios_clasificacion.SUBTIPO?.mayor_value,
      tamanio_cliente:item.criterios_clasificacion.TAMANIO?.mayor_value,
    
    }) )]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };



    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  {...[...dataSetProdctos].find(prod=>prod.cod === cod_prod)};
      product.direccion = product.direccion_contacto;
      product.usuarios = product.usuarios.map( user=>({
        usuario_cliente:{...user }
      }));
      product.productos = product.productos.map( prod=>{
       
        return {
          producto:{label:prod.nombre_proucto,value:prod.cod_producto},
          criterio_aceptacion:prod.criterio_aceptacion
        };
      });
      product.direcciones = product.direcciones.map( dir=>({...dir,
        municipio:{value:dir.value_municipio,label:dir.label_municipio},
        direccion:dir.direccion_contacto
      }));
      product.vendedor  = product.cod_usuario_vendedor?{value:product.cod_usuario_vendedor,label:product.nombre_vendedor} :null;
      setProductoSeleccionado(product);
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);

    }



    const onOpenModalItem = (edit=false)=>{

      if (!edit){
        setProductoSeleccionado({});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }

    const onSaveDataForm = async(typeAction,dataForm)=>{
      dataForm.direcciones = dataForm.direcciones.map( (ele)=>({...ele,municipio:ele.municipio.value}));
      dataForm.productos = dataForm.productos.map( item=>({producto:item.producto.value,criterio_aceptacion:item.criterio_aceptacion}));
      dataForm.usuarios = dataForm.usuarios.map( (ele)=>({...ele.usuario_cliente}));
      dataForm.vendedor = dataForm.vendedor.value;
     console.log("save",{dataForm});
   
    
     delete  dataForm.nombre_clasificacion_cliente;
   
      const urlService = typeAction === FormActions.AGREGAR?'maestros-marketplace/add-cliente':'maestros-marketplace/edit-cliente/'+dataForm.cod;
 
        let payload =  {...dataForm  };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const onSearchMunicipio = async (value_search) => {

      if (value_search) {
        const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
          search_query: value_search
        })
        return value.map(mun => ({
          label: `${getLabelMunicipio(mun.desc_departamento,mun.descripcion)}`,
          value: mun.cod
        }))
  
      }
  
  
  
    }

    const onSearchVendedor = async (evt,value_search) => {

      if (value_search && value_search.length > 2) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/filtrar-vendedores", {
            search_query: value_search
          });
          setVendedores(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const searchMunicipiosOrigen = async (event, newInputValue) => {
      try {
        let res = await onSearchMunicipio(newInputValue);
        setMunicipios( res );
      } catch (e) {
    
      }
    }

    const onSearchProducto = async (evt,value_search) => {

      if (value_search?.length > 2 && value_search.length > 2) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          setProductosOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
   }
   const onSearchClienteUsuario = async (evt,value_search) => {

    if (value_search?.length > 2 && value_search.length % 2 === 0) {
       try{

        const { data: { value } } = await AxiosInstance.post("maestros-marketplace/obtener-usuarios-to-client", {
          search_query: value_search
        });
        console.log("usuarios op",value);
        setUsuariosOptions(value);
        return value;
       }catch(e){
        console.log(e.message);
        return [];
       }

    }
 }


    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"Cod erp",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"Razon social",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nit",
        keyValue:"nit",
        label:"Nit/ Cedula",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
       {
      
        key:"email_notificaciones",
        keyValue:"email_notificaciones",
        label:"Correo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"text",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"celular_notificaciones",
        keyValue:"celular_notificaciones",
        label:"Celular",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_clasificacion_cliente",
        keyValue:"nombre_clasificacion_cliente",
        label:"Clasificacion cliente",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip label={props.value} />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button size="small" onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar  cliente":'Modificar cliente',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
       
        {
          key:"razon_social",
          keyValue:"razon_social",
          label:"Razon social",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"nit",
          keyValue:"nit",
          label:"Nit o cedula del cliente",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"email_notificaciones",
          keyValue:"email_notificaciones",
          label:"Correo",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"celular_notificaciones",
          keyValue:"celular_notificaciones",
          label:"Celular",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"cod_erp",
          keyValue:"cod_erp",
          label:"cod_erp",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"cod_tipo_cliente",
          keyValue:"cod_tipo_cliente",
          label:"Tipo de cliente",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            items:roles,
            size:"small"
          }
        },
        {
          key:"vendedor",
          keyValue:"vendedor",
          label:"Vendedor",
          responsiveSize:12,
          component: AutoCompleteInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"autoComplete",
               name:'municipio',
                fullWidth: true,
                isLoading: false,
                onInputChange: onSearchVendedor,
                options: vendedores || [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
        },
        {
          key:"tipo_cliente",
          keyValue:"tipo_cliente",
          label:"TIPO DE CLIENTE",
          responsiveSize:4,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            disabled:true,
            items:roles,
            size:"small"
          }
        },
        {
          key:"subtipo_cliente",
          keyValue:"subtipo_cliente",
          label:"SUBTIPO",
          responsiveSize:4,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            disabled:true,
            items:roles,
            size:"small"
          }
        },
        {
          key:"tamanio_cliente",
          keyValue:"tamanio_cliente",
          label:"TAMAÑO",
          responsiveSize:4,
          component:InputWithLabel,
          inputProps:{
            disabled:true,
            type:"text",
            items:roles,
            size:"small"
          }
        }
       
      
      ],
      arrayInputs:[

        {
          label:"Sucursales ERP",
          key:"sucursales",
          keyValue:"sucursales",
          subSchema:SucursalesYupValidation,
          ItemRender:SucursalesERP,
          itemRenderProps:{
            delete:false,
            add:false
          },
          inputs:[
            {
              key:"cod_erp",
              keyValue:"cod_erp",
              label:"Codigo erp",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
            {
              key:"municipio",
              keyValue:"municipio",
              label:"Municipio",
              component: AutoCompleteInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"autoComplete",
               name:'municipio',
                fullWidth: true,
                isLoading: false,
                onInputChange: searchMunicipiosOrigen,
                options: municipios || [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
            {
              key:"direccion",
              keyValue:"direccion",
              label:"Direccion",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
            {
              key:"celular",
              keyValue:"celular",
              label:"Celular",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
          ]
        },
        {
          label:"Direcciones de entrega",
          key:"direcciones",
          keyValue:"direcciones",
          subSchema:AddressYupValidation,
          ItemRender:AddressListItem,
          itemRenderProps:{
            delete:false,
            add:true
          },
          inputs:[
            {
              key:"descripcion",
              keyValue:"descripcion",
              label:"ID ",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
            {
              key:"municipio",
              keyValue:"municipio",
              label:"Municipio",
              component: AutoCompleteInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"autoComplete",
               name:'municipio',
                fullWidth: true,
                isLoading: false,
                onInputChange: searchMunicipiosOrigen,
                options: municipios || [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
            {
              key:"direccion_contacto",
              keyValue:"direccion_contacto",
              label:"Direccion",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
            {
              key:"celular",
              keyValue:"celular",
              label:"Celular",
              component:InputWithLabel,
              inputProps:{
                type:"text",
                size:"small"
              }
            },
          ]
        },
        {
          label:"Usuarios asociados (compradoras)",
          key:"usuarios",
          keyValue:"usuarios",

          subSchema:ContactosYupValidation,
          ItemRender:ContactosListItem,
          inputs:[
            {
              responsiveSize:12,
              key:"usuario_cliente",
              keyValue:"usuario_cliente",
              label:"Usuario cliente",
              component:AutoCompleteInputWithLabel,
              inputProps:{
                size:"small",
                typeInput:'autoComplete',
                name: 'usuario_cliente',
                size:"small",
                fullWidth: true,
                isLoading: false,
                multiple:false,
                PopperComponent:(props)=><div hidden={!props.open} >
                 
                   {props.children}
                </div>,
                onInputChange: onSearchClienteUsuario,
                options: usuariosOptions,
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
          ]
        },
        {
          label:"Listado de productos",
          key:"productos",
          keyValue:"productos",
          subSchema:ProductoPortafolioYupValidation,
          ItemRender:ProductosListItem,
          inputs:[
            {
              responsiveSize:12,
              key:"producto",
              keyValue:"producto",
              label:"Producto",
              component:AutoCompleteInputWithLabel,
              inputProps:{
                size:"small",
                typeInput:'autoComplete',
                name: 'producto',
                size:"small",
                fullWidth: true,
                isLoading: false,
                multiple:false,
                PopperComponent:(props)=><div hidden={!props.open} >
                 
                   {props.children}
                </div>,
                onInputChange: onSearchProducto,
                options: productosOptions || [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
            {
              responsiveSize:12,
              key:"criterio_aceptacion",
              keyValue:"criterio_aceptacion",
              label:"Criterios de aceptacion",
              component:InputWithLabel,
              inputProps:{
                size:"small",
                type:"text",
                multiline:true,
                maxRows:4,
                size:"small",
              }
            },
            
          ]
        }
      ]
    } ;


    const onSearchProductByName = (evt)=>{

      if ( evt.target.value.length > 3 && evt.target.value.length % 2 ){
        setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
      }
      
     
    }
   
    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }


   
    <Grid container spacing={2} >
    <Grid item sm={12} xs={12} md={4} >

<InputWithLabel
  label="Buscar cliente"

  onChange={onSearchProductByName}
  endAdornment={<Search />}
/>


</Grid>

        <Grid item sm={12} xs={12} md={12} >
        {
          /* 
            <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo cliente</Button>
          */
        }
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}